export default __webpack_public_path__ + "static/media/ribbon.055aa16f.svg";